import PopupComponent from '../popup-component';
import template from './template';

export default class OldFwVersionPopup extends PopupComponent {
  constructor(config) {
    super();
    this.popup = null;
    const popupConfig = {
      id: 'popup_content_old_fw_version',
      initializedCallback: () => this._onInit(),
      buttons: [
        {
          id: 'continue',
          class: 'positive',
          shouldClose: true,
          text: this.t('popupDefaultImageSuccessOK'),
          callback: () => config.onProceed(),
        },
      ],
    };
    this.title = this.t('popupOldFwVersionTitle');
    this.msg = this.t('popupOldFwVersionMessage');
    this.popup = this.create(popupConfig);
    this.createContentElement('popup_content_old_fw_version', template);
  }

  _onInit() {
    this.popup.wrapperElement.querySelector('.popup_content .old_fw_version_title').innerHTML = this.title;
    this.popup.wrapperElement.querySelector('.popup_content .old_fw_version_message').innerHTML = this.msg;
    const robo = this.popup.wrapperElement.querySelector('.popup_content .robo_image');
    robo.classList.add('robo_happy');
  }
}
